/* istanbul ignore next */
export const noop: VoidFunction = () => {};
